import React, { useState, useRef, useEffect } from 'react';
import { Table, TableBody, TableRow, TableCell } from '@mui/material'
;
import useTableFijo from "../../useTableFijo"
import { Mensaje, MensajeSiNo } from '../../mensajes2';

import { Dimmer} from "../../spinner";


import axios from 'axios';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import { formatMoneda, validaSoloNumero } from '../../../util/varios';
import CatalogoComercio from '../../../catalogos/catalogoComercio';



export const FacturacionEtax = (props) => {

    moment.locale('es-us');

    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const anioActu = JSON.parse(localStorage.getItem('anioactu'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [tipoImpu, setTipoImpu] = useState(0);
    const [catalogoC, setCatalogoC] = useState(false);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mostrar2, setMostrar2] = useState(false);
    const [records, setRecords] = useState([]);
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({
        concepto: '',
        seleccionados: 0,
        credito: '0,00',
        total: '0,00'
    });
    const [valuess, setValuess] = useState({
        idcontribuyente: '',
        nombre: '',
        rif: '',
        direccion: ''
    });
    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');
    const cmbRif = useRef("");
    const txtNRif = useRef();
    const txtNombre = useRef();
    const txtDireccion = useRef();
    const headCells = [
        { id: 'idfactura', label: 'N° DE PAGO', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'fechaenterami', label: 'FECHA PAGO', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'periodo', label: 'CONCEPTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'numrete', label: 'REFERENCIA', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'numrete', label: 'BANCO DESTINO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },

        { id: 'numrete', label: 'MONTO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },

    ]

    const txtFecha = useRef()

    const handleSearch = e => {

        let target = e.target;

        let fechaFiltro = moment.utc(txtFecha.current.value).format('YYYY-MM-DD'); // Convertir la fecha del input al formato adecuado


        setFilterFn({

            fn: items => {

                if (target.value === "") {

                    return items;

                } else {

                    return items.filter(x => {

                        let fechaPago = moment.utc(x.fecha_pago).format('YYYY-MM-DD');

                        let result = moment.utc(fechaPago).isBefore(fechaFiltro);


                        if (result &&

                            (moment.utc(fechaPago).format('DD/MM/YYYY').includes(target.value)

                                || x.concepto.toLowerCase().includes(target.value.toLowerCase())

                                || x.referencia_banco.toString().toLowerCase().includes(target.value.toLowerCase())

                                || formatMoneda(x.monto.toString().replace('.', ','), ',', '.', 2).includes(target.value)

                                || x.bancodestino.includes(target.value))) {

                            return x;

                        }

                    });

                }

            }

        });

    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);


    const handleCloseSi = () => {

        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }


    const blanquear = () => {


        cmbRif.current.value = ''
        txtNRif.current.value = ''
        txtNombre.current.value = ''
        txtDireccion.current.value = ''
        setRecords([])

        setMostrar2(false);

        setValues({
            concepto: '',
            seleccionados: 0,
            credito: '0,00',
            total: '0,00'
        });
    }


    const handleCatalogo = () => {
        switch (tipoImpu) {
            case 0:
            case 1:
                if (!catalogoC) {
                    setCatalogoC(true);
                } else {
                    setCatalogoC(false);
                }
                break;

            default:
                break;
        }
    }

    const handleAceptaCatalogo = (id) => {

        setCatalogoC(false);

        datosContribuyente(id, 'catalogo');

    }

    const seleccionarFacturasPagasEtax = (rif) => {

        let endpoint = `${op.conexion}/api/industria/allpagosetax?rif='${rif ? rif.trim() : ''}'`;
        console.log(endpoint);
        console.log('aqui el rif   ->' + rif)
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setRecords(response.data)







                    setActivate(false);

                }
            })
            .catch(function (error) {
                /*  setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error.response.data.message,
                   icono: "error",
                 }); */
                console.log(error.response.data.message);
            });
    };

    const datosContribuyente = (idcontri, tipo) => {
        let campos = '*';
        let nomtab = 'comercio';
        let nomid = 'rif';

        let nrif = tipo === 'catalogo' ? idcontri : cmbRif.current.value + idcontri


        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${nrif}&nomtab=${nomtab}&nomid=${nomid}`;


        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data !== '') {



                    console.log(response.data)
                    cmbRif.current.value = response.data.rif.substring(0, 1)
                    txtNRif.current.value = response.data.rif.substring(1, response.data.rif.length)
                    txtNombre.current.value = response.data.nombre;
                    txtDireccion.current.value = response.data.direccion;
                    seleccionarFacturasPagasEtax(response.data.rif)


                } else {
                    //if (teclas === 13) {
                    setActivate(false);
                    setTimeout(() => {
                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Contribuyente no existe...', icono: 'error' });

                        valuess.rif = "";
                        txtNombre.current.value = "";
                        txtDireccion.current.value = "";
                        blanquear();
                    }, 100);
                    //}
                }
            }

            //setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }

    const validarContribuyente = (event) => {
        event.preventDefault();

        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {

                datosContribuyente(event.target.value, '');
            } else {
                //txtContribuyente.current.value = '';
            }
        }
    };

    const cancelar = (e) => {
        e.preventDefault();
        valuess.idcontribuyente = "";
        valuess.rif = "";
        valuess.nombre = "";
        valuess.direccion = "";
        props.onHideCancela();
        blanquear();
    }


    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {

            }}

        >
            <Modal.Header className='azulGradiant'>
                <div className='fw-bold text-light'><h3 className='text-capitalize'>Facturación ETAX</h3></div>
                <button className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
                <div className='titulos' style={{ height: "auto", minHeight: "auto", maxHeight: "90vh", overflow: "auto" }}>
                    <div className="container">

                        <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos del Contribuyente </legend>
                            <div className='col-md-12 row mx-auto px-0'>



                                <div className="input-group input-group-sm col-md-3 mb-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Rif:</label>

                                    <select
                                        aria-label="Default select example"

                                        ref={cmbRif}
                                        className="form-select form-select-sm col-md-3"
                                        id="inputLetraRif"

                                    >
                                        <option value="J">J</option>
                                        <option value="V">V</option>
                                        <option value="G">G</option>
                                        <option value="E">E</option>
                                        <option value="P">P</option>
                                    </select>
                                    <input type="text" ref={txtNRif} onKeyUp={validarContribuyente} className="form-control bg-light" autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='rif' />
                                    <button className='btn btn-info' onClick={handleCatalogo}><i className='fa fa-search'></i></button>

                                </div>


                                <div className="input-group input-group-sm col-md-9 px-0 mb-2">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombres:</label>
                                    <input type="text" ref={txtNombre} disabled className="form-control bg-light" autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='nombre' />
                                </div>

                            </div>

                            <div className="input-group input-group-sm mx-auto col-md-12">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Dirección:</label>
                                <input type="text" ref={txtDireccion} disabled className="form-control bg-light" autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='direccion' />
                            </div>

                        </fieldset>
                        <div className='col-md-12 py-1'></div>
                        <fieldset className='border-azul rounded row m-0'>
                            <legend className="float-none m-0 w-auto" >Pagos Registrados</legend>
                            <div className="col-md-12 mx-auto row px-0">

                                <div className="col-md-3">
                                    <input
                                        className="form-control form-control-sm rounded-pill mr-sm-2"
                                        style={{ border: "1px solid #007bff" }}
                                        type="search"
                                        placeholder="Buscar"
                                        onChange={handleSearch}
                                        aria-label="Search"
                                    />
                                </div>
                                <div className='col-md-6'></div>
                                <div class="input-group input-group-sm mb-1 col-md-3">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">Fecha:</span>
                                    <input type="date" ref={txtFecha} defaultValue={moment.utc(fechaSistema).format('YYYY/MM/DD')} class="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>


                                <div className="col-md-12" style={{ margin: "auto" }} >
                                    <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >
                                        <TblHead />

                                        <tbody>
                                            {

                                                records && records.map((item, index) => (
                                                    <tr key={item.idfactura + item.periodo} style={{ padding: "0" }}>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numero}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fecha_pago).format('DD/MM/YYYY')}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.concepto}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.referencia_banco}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.bancodestino}</td>

                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>

                                                    </tr>

                                                ))
                                            }
                                        </tbody>

                                    </TblContainer>
                                    {/*<TblPagination />*/}

                                </div>


                            </div>
                        </fieldset>
                    </div>
                </div>
            </Modal.Body >
            <Modal.Footer>
                <button onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <CatalogoComercio titulo={titulo} mensaje={msg}
                show={catalogoC}
                onHideCancelaCatCom={handleCatalogo}
                onHideAceptaCatCom={handleAceptaCatalogo}
                llamado={1}
            />
        </Modal >
    );
}